import type { EventConfig, EventPropertiesContext } from '../capture.types';

/**
 * Resolves the object|function `properties` config into a flat record.
 * `ctx` is optional: non-API callers pass nothing, and their resolver functions
 * accept no arguments.
 */
export const resolveEventProperties = async <
  TBody = unknown,
  TResponse = unknown,
  TParams = unknown,
  TQuery = unknown,
>(
  properties: EventConfig<TBody, TResponse, TParams, TQuery>['properties'],
  ctx?: EventPropertiesContext<TBody, TResponse, TParams, TQuery>,
): Promise<Record<string, unknown>> => {
  if (!properties) return {};
  if (typeof properties === 'function') {
    return (
      (await properties(
        ctx as EventPropertiesContext<TBody, TResponse, TParams, TQuery>,
      )) ?? {}
    );
  }
  return properties;
};
